export enum AnnotationType {
  Note = 1,
  Correction,
}

export enum AnnotationScope {
  Session = 1,
  Run,
}

export enum AnnotationTargetType {
  Name = 1,
  Item,
  Cycle,
  Record,
  Signature,
  PCA,
  Spotfile,
  DistanceMatrix,
  Tag,
}
export type AnnotationTarget = {
  type: AnnotationTargetType;
  item?: string;
  cycle?: string;
  pca_type?: string;
  record_id?: number;
  tag?: string;
};

export type Annotation = {
  type: AnnotationType;

  scope: AnnotationScope;
  scopeID: string;
  scopeSource?: string;

  target?: AnnotationTarget;

  content: string;

  authorName: string;
  createdAt: string;
};
